<template>
    <span class="convert-unit">{{ valueConverted }}</span>
</template>

<script>
    export default {
        name: "convertUnit",
        
        props: {
            value: {
                required: true
            },
            currentUnit: {
                required: true
            }
        },
        
        computed: {
            valueConverted(){
                const unit = this.currentUnit;
                const value = parseInt(this.value);
                
                if(unit === 'g' && value >= 1000){
                    const valueConverted = value / 1000;
                    return `${valueConverted} kg`;
                }
                
                return `${value} ${unit}`;
                
            }
        }
    }
</script>